import { useLocation } from "react-router-dom";
import { RuneLogo } from "@/components/RuneLogo";
import { Button } from "@/components/ui/button";
import { PRIMARY } from "@/components/landing/shared";

export const LandingNav = ({ user, login, startTeam, navigate }) => {
  // Off the landing page (e.g. /demo) the in-page sections don't exist, so hashes
  // must point back at the landing route to navigate at all.
  const onLanding = useLocation().pathname === "/";
  const to = (h) => (onLanding ? h : `/${h}`);
  return (
  <header data-testid="landing-nav" className="sticky top-0 z-50 border-b border-[color:var(--rb-border)] bg-[color:var(--rb-void)]/80 backdrop-blur">
    <div className="mx-auto flex h-16 max-w-6xl items-center px-4 sm:px-6">
      <a href={to("#top")} className="flex items-center gap-2.5">
        <RuneLogo className="h-7 w-7" />
        <span className="rb-display text-lg font-semibold tracking-tight text-[color:var(--rb-text)]">Runebox</span>
      </a>
      <nav className="ml-8 hidden items-center gap-6 md:flex">
        {[["How it works", "#how"], ["Pricing", "#offer"], ["Free gallery", "#marketplace"], ["FAQ", "#faq"]].map(([l, h]) => (
          <a key={h} href={to(h)} className="text-sm text-[color:var(--rb-text-dim)] transition-colors hover:text-[color:var(--rb-text)]">{l}</a>
        ))}
        {!user && (
          <button onClick={() => navigate("/demo")} data-testid="landing-nav-demo" className="text-sm text-[color:var(--rb-text-dim)] transition-colors hover:text-[color:var(--rb-text)]">See it in action</button>
        )}
      </nav>
      <div className="ml-auto flex items-center gap-2">
        {user ? (
          <Button onClick={() => navigate("/build")} data-testid="landing-nav-openapp" className={`rounded-lg ${PRIMARY}`}>Open app</Button>
        ) : (
          <>
            <Button onClick={login} variant="ghost" data-testid="landing-nav-login" className="text-[color:var(--rb-text-dim)] hover:text-[color:var(--rb-text)]">Log in</Button>
            <Button onClick={startTeam} data-testid="landing-nav-cta" className={`rounded-lg ${PRIMARY}`}>Start a team registry</Button>
          </>
        )}
      </div>
    </div>
  </header>
  );
};
